import { ButtonSize } from "@components/button/button-constants";
import { classNames } from "@helpers/css";

import AddButton from "../add-button";
import { emptyRoleColWidth } from "../helpers";

// A level this track has no role on. Criteria written per role need one, so
// the cell offers to create it rather than just saying there isn't one.
const EmptyCriteriaCell = ({ onAddRole }: { onAddRole?: () => void }) => (
  <td
    className={classNames(
      emptyRoleColWidth,
      // The table's unused background (as in the add-level column), so a
      // level this track has no role on reads as empty rather than blank.
      "p-4 border align-middle bg-content-background",
    )}
  >
    <div className="flex flex-col items-center justify-center gap-2 text-center">
      <div className="text-gray-400 text-xs">
        Role not defined at this level
      </div>
      {onAddRole && (
        <AddButton
          icon="userPlus01"
          size={ButtonSize.medium}
          text="Add role for this track"
          aria-label="Career track: Add role for level"
          onClick={onAddRole}
        />
      )}
    </div>
  </td>
);

export default EmptyCriteriaCell;
